import * as React from "react";
import { styled } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import {
    Paper,
} from "@mui/material";
import { APIPath, token } from "../../config/api";

const StyledTableContainer = styled(TableContainer)(({ theme, open }) => ({
    width: open ? "80%" : "94%",
    transition: "width 0.3s ease",
    paddingTop: "7px",
    marginLeft: open ? "243px" : "69px",
    position: "relative",
    borderRadius: "0px",
    overflow: "hidden",
    marginBottom: "20px",
    boxShadow: "none"
}));


const PackageDetail = ({ open, close, closeform, attractionEditedId, priceDescription, expectation,
    title, description,
    imageCoverP, imageBannerP,
    fromCountry, fromCountryName, place, placeName,
    inclusion, exclusion,
    category, categoryName,
    currency, loadPackagesList, cancellationPolicy
}) => {
    document.body.style.overflow = 'hidden';

    const [isLoading, setIsLoading] = React.useState(false);
    const method = attractionEditedId?.length > 0 ? 'PATCH' : 'POST';
    const [imageCover, setImageCover] = React.useState(null);
    const [imageBanner, setImageBanner] = React.useState(null);

    const convertUrlToFile = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        const fileName = url.split('/').pop();
        return new File([blob], fileName, { type: blob.type });
    };

    const AddPackageData = {
        title: title,
        attractionOverview: description,
        attractionDescription: description,
        categoryId: category,
        categoryName: categoryName,
        location: {
            city: placeName,
            cityId: place,
            country: fromCountryName,
            countryId: fromCountry
        },
        // website: "http://www.exampleattraction.com",
        // contactNumber: "+1234567890",
        // categories: ["Desert Safari Tours"],
        accessibility: {
            wheelchairAccessible: true,
            parkingAvailable: true,
            transportationAvailable: true
        },
        guidedTours: {
            available: true,
            cost: 20.5
        },
        pickupOffered: true,
        // pickupDropOff: [
        //     "Pick-up Timing: 15:30 - 16:30 from Burduabi and Deira(approximate time only, will change depending on the sunset timing).",
        //     "Pick up from other parts of UAE is available at an extra charge.(Depends on Location )."
        // ],
        includedServices: inclusion,
        excludedServices: exclusion,
        cancellationRefundPolicy: cancellationPolicy,
        // images: [
        //     "http://www.exampleattraction.com/image1.jpg",
        //     "http://www.exampleattraction.com/image2.jpg"
        // ],
        expectations: expectation,
        // costHeading: [
        //     {
        //         coloumnName: "Standard Entry"
        //     },
        //     {
        //         coloumnName: "Adult"
        //     },
        //     {
        //         coloumnName: "Child  (Above 3 )"
        //     }
        // ],
        price: priceDescription,
        thumbnailImage: imageCover,
        bannerImage: imageBanner,
    }
    const AddNewPackage = async () => {
        const coverFile = await convertUrlToFile(imageCoverP);
        const bannerFile = await convertUrlToFile(imageBannerP);
        setImageCover(coverFile);
        setImageBanner(bannerFile);
        sendDataToServer(AddPackageData, coverFile, bannerFile);
    };
    const sendDataToServer = async (AddPackageData, imageCover, imageBanner) => {
        try {
            showLoader();
            const formData = new FormData();
            formData.append('jsonData', JSON.stringify(AddPackageData));
            formData.append('thumbnail', imageCover);
            formData.append('banner', imageBanner);
            const response = await fetch(`${APIPath}/api/v1/agency/attractions?id=${attractionEditedId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                method: method,
                mode: 'cors',
                body: formData
            });
            hideLoader();
            if (!response.ok) {
                console.log(response);
                alert("Failed to Edit Attraction");
                return;
            }
            if (method === 'POST') {
                alert("New Attraction added...");
            }
            if (method === 'PATCH') {
                alert("Attraction updated...")
            }
            const responseData = await response.json();
            close();
            closeform();
            loadPackagesList();
        } catch (error) {
            console.error('Error sending data to server:', error);
            hideLoader();
            alert('An error occurred while Editing the Attraction');
        }
    };
    const showLoader = () => {
        setIsLoading(true);
    };

    const hideLoader = () => {
        setIsLoading(false);
    };

    return <StyledTableContainer component={Paper} open={open}>
        <div className="admin-package-detail-container" >
            <div className="admin-package-detail-page">
                <div className="back-and-text">
                    <div className="back">
                        <button onClick={close} style={{ background: "none", border: "none", cursor: "pointer" }}>
                            <img src="backicon.svg" alt="back-icon" />
                        </button>
                    </div>
                    <div className="text">
                        <h2>Attraction Details</h2>
                    </div>
                </div>
                <div className="package-basic-details">
                    <h3>Basic Details</h3>
                    <div className="admin-pkg-title-description">
                        <div className="title">
                            <h4>Title</h4>
                        </div>
                        <div className="title-value">
                            <h5>{title}</h5>
                        </div>
                        <div className="description">
                            <h4>Description</h4>
                        </div>
                        <div className="description-value">
                            <h5>{description}</h5>
                        </div>
                    </div>
                    <div className="admin-pkg-title-description-pic">
                        <div className="title">
                            <h4>Cover Photo</h4>
                        </div>
                        <div className="title-value">
                            <img src={imageCoverP} alt="cover" height="100px" width="150px" />
                        </div>
                        <div className="description">
                            <h4>Banner Photo</h4>
                        </div>
                        <div className="description-value">
                            <img src={imageBannerP} alt="banner" height="100px" width="150px" />
                        </div>
                    </div>
                </div>
                <div className="package-basic-details">
                    <h3>Location Details</h3>
                    <div className="location-details">
                        <div className="title">
                            <h4>Country</h4>
                        </div>
                        <div className="title-value">
                            <h5>{fromCountryName}</h5>
                        </div>
                        <div className="description">
                            <h4>Places</h4>
                        </div>
                        <div className="description-value">
                            <h5>{placeName}</h5>
                        </div>
                    </div>
                </div>
                <div className="package-form-inclusion-exclusion">
                    <h2>Cancellation Policy</h2>
                    <div className="package-form-cancellation-polocy">
                        {cancellationPolicy.map((val, id) => {
                            return <ul key={id}>
                                {val &&  <li>{val}</li>}
                            </ul>
                        })}
                    </div>
                </div>
                <div className="package-form-inclusion-exclusion">
                    <h2>Category Name</h2>
                    <div className="package-form-cancellation-polocy">
                        <p>{categoryName}</p>
                    </div>
                </div>
                <div className="package-basic-details">
                    <h3>Inclusions/Exclusions</h3>
                    <div className="location-details">
                        <div className="title">
                            <h4>Inclusions</h4>
                        </div>
                        <div className="title-value">
                            {inclusion?.map((val, id) => {
                                return <ol key={val._id}>
                                    <p>{val}</p>
                                </ol>
                            })}
                        </div>
                        <div className="description">
                            <h4>Exclusions</h4>
                        </div>
                        <div className="description-value">
                            {exclusion?.map((val, id) => {
                                return <ol key={val._id}>
                                    <p>{val}</p>
                                </ol>
                            })}
                        </div>

                    </div>
                </div>
                <div className="package-basic-details">
                    <h3>Meeting Points</h3>
                    {expectation?.map((val, id) => {
                        return <>
                            <div className="location-details">
                                <div className="title">
                                    <h4>Location:</h4>
                                </div>
                                <div className="title-value">
                                    <h5>{val.location}</h5>
                                </div>
                                <div className="description">
                                    <h4>Description:</h4>
                                </div>
                                <div className="description-value">
                                    <h5>{val.description}</h5>
                                </div>
                                {/* <div className="description">
                                    <h4>Open Time:</h4>
                                </div>
                                <div className="description-value">
                                    <h5>{val.time}</h5>
                                </div> */}
                            </div>
                        </>
                    })}
                </div>
                <div className="package-price" style={{ display: "block" }}>
                    <h3>Pricing</h3>
                    <div style={{ width: "70%", marginTop: "1rem" }} >
                        {priceDescription?.map((val, id) => {
                            return <>
                                <div style={{
                                    display: "flex", justifyContent: "space-between",
                                    marginBottom: "1rem"
                                }}>
                                    <div>
                                        <p>Description</p>
                                        <h4>{val.description}</h4>
                                    </div>
                                    <div>
                                        <p>Adults</p>
                                        <h4>{currency} {val.adultPrice}</h4>
                                    </div>
                                    <div>
                                        <p>Children</p>
                                        <h4>{currency} {val.childPrice}</h4>
                                    </div>
                                </div>
                            </>
                        })}
                    </div>
                </div>
                <div className="package-delete-edit-btn">
                    {isLoading ? (
                        <div className="loader"></div>) : (
                        <>
                            <button id="delete" onClick={close}>Back</button>
                            <button id="edit" onClick={AddNewPackage} disabled={isLoading}>Submit</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    </StyledTableContainer>
};

export default PackageDetail;
